import { render } from "./LoadsView.vue?vue&type=template&id=580b37c3&ts=true"
import script from "./LoadsView.vue?vue&type=script&lang=ts"
export * from "./LoadsView.vue?vue&type=script&lang=ts"

import "./LoadsView.vue?vue&type=style&index=0&id=580b37c3&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__